<script>
  // The app's one overlay surface. Help content and the per-column editor both
  // slide in from the right, so an analyst learns the affordance once. Focus
  // moves into the panel on open, stays inside it while it is open, and returns
  // to whatever opened it on close; Escape always closes.
  let { title, open = false, onclose = () => {}, width = 440, children } = $props();

  let panel = $state(null);
  let opener = null;

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  $effect(() => {
    if (!open) return;
    opener = document.activeElement;
    panel?.querySelector('.drawer-close')?.focus();
    return () => opener?.focus?.();
  });

  function onKeydown(event) {
    if (event.key === 'Escape') { onclose(); return; }
    if (event.key !== 'Tab' || !panel) return;
    const items = [...panel.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const edge = event.shiftKey ? items[0] : items[items.length - 1];
    if (document.activeElement !== edge) return;
    event.preventDefault();
    (event.shiftKey ? items[items.length - 1] : items[0]).focus();
  }
</script>

{#if open}
  <button class="drawer-overlay" aria-label="Close {title}" onclick={onclose}></button>
  <div
    class="drawer"
    style="width: min({width}px, 96vw)"
    bind:this={panel}
    role="dialog"
    aria-modal="true"
    aria-label={title}
    tabindex="-1"
    onkeydown={onKeydown}
  >
    <div class="drawer-head">
      <h2 class="drawer-title">{title}</h2>
      <button class="drawer-close" aria-label="Close {title}" onclick={onclose}>×</button>
    </div>
    <div class="drawer-body">{@render children()}</div>
  </div>
{/if}
